import { useEffect, useRef, useState } from 'react';
import * as React from 'react';

import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import _ from 'lodash';
import { FormInput } from '../../Form/FormInput';
import DpdMap from './DpdMap';
import { Loader } from '../../../Defaults/Loader';
import DpdMapDetail from './DpdMapDetail';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { DsiSvgIcon as SvgIcon, IconType } from '../../General/SvgIcon';
// const request = require('request');
import { usePlacesWidget } from 'react-google-autocomplete';
import DpdMapWrapper from './DpdMapWrapper';
import { prop } from '../../../../utilities';
// import * as request from 'request';

interface Props {
  handleOpen: any;
  handleChoose: any;
  lang: string;
  selected: any;
}

const CloseIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.textPrimary};
`;

const MainWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  --tw-bg-opacity: 0.8;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  width: 100%;
  height: 100%;
  z-index: 200;

  text-rendering: geometricprecision;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  color: #2f3136;
`;

const SecondWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  --transform-translate-x: 50%;
  --transform-translate-y: 50%;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  height: 650px;
  width: 80%;
  max-width: 80rem;
  border-radius: 0.25rem;
  z-index: 200;
  --tw-translate-y: -50%;
  --tw-translate-x: -50%;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y))
    rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
    scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  left: 50%;
  top: 50%;
`;

const HeaderWrapper = styled.div`
  display: flex;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  justify-content: space-between;
  border-color: #f3f4f6;
  border-bottom-width: 2px;
`;

const Header = styled.h2`
  font-weight: 700;
`;

const ThirdWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 33.333333%;
  height: 520px;
  z-index: 200;
  min-width: 320px;
`;

const FormWrapper = styled.div`
  padding: 1rem;
  width: 100%;
  max-height: 56px;
  box-sizing: border-box;
  border: 0 solid #e5e7eb;
`;

const CustomFormInput: any = styled.input`
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.078);
  --tw-shadow-colored: inset 0px 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 transparent),
    var(--tw-ring-shadow, 0 0 transparent), var(--tw-shadow);
  --tw-border-opacity: 1;
  border-color: rgba(204, 204, 204, var(--tw-border-opacity));
  border-width: 1px;
  border-radius: 4px;
`;

const ResetSearchButton = styled.button`
  position: relative;
  top: 35px;
  right: 230px;
`;

const CountText = styled.p`
  padding: 1rem;
`;

const DetailWrapper = styled.div`
  width: 100%;
  border-color: #f3f4f6;
  max-height: 400px;
  overflow: auto;
`;

const MapWrapper = styled.div`
  width: 100%;
  height: 520px;
  overflow: hidden;
  padding: 15px;
`;

function DpdMapModal(props: Props) {
  let updateDataTimeout: any = null;
  const { handleOpen, handleChoose, selected, lang } = props;
  const [spsShopsSearchValue, setSpsShopsSearchValue] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [activeShop, setActiveShop] = useState(null as any);
  const [markers, setMarkers] = useState([] as any);
  const [isLoading, setIsLoading] = useState(false);
  const [allDpdPoints, setAllDpdPoints] = useState([] as any);

  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: 'AIzaSyAtjlvnt8r2LXlW8Q8NnEvrP2nuditIfXY',
    options: {
      types: ['(cities)'],
      fields: ['formatted_address', 'address_components', 'geometry'],
      componentRestrictions: {
        country: [props.lang === 'cz' ? 'cz' : 'sk'],
      },
    },
    onPlaceSelected: (place: any) => {
      if (!place) {
        return;
      }
      const { address_components, formatted_address } = place;
      setIsLoading(true);
      if (!address_components || address_components.length <= 1) {
        setSpsShopsSearchValue(formatted_address);
      } else {
        setSpsShopsSearchValue(
          prop(
            address_components.find(
              a =>
                a.short_name &&
                a.short_name.length >= 3 &&
                ['postal_code', 'locality'].includes(prop(a, 'types.0')),
            ) || formatted_address,
            'short_name',
          ),
        );
      }
      const latitude = place.geometry?.location?.lat();
      const longitude = place.geometry?.location?.lng();
      setActiveShop({
        id: '',
        latitude: latitude ? +latitude : latitude,
        longitude: longitude ? +longitude : longitude,
      });
    },
  });

  React.useEffect(() => {
    if (lang === 'cz') {
      const countryId = lang === 'cz' ? 203 : 703;
      // request(
      //   `https://pickup.dpd.cz/api/get-all?country=${countryId}`,
      //   function(error, response, body) {
      //     if (!error && +response.statusCode === 200) {
      //       const importedJSON = JSON.parse(body);
      //       const dpdPoints = importedJSON.data.items
      //         .filter(item => item.pickup_network_type !== 'dpd_box')
      //         .map(ps => {
      //           ps.postcode_split = `${ps.postcode.slice(0, 3) ||
      //             ''} ${ps.postcode.slice(3, 5) || ''}`;
      //           ps.normalizedStreet = ps.street
      //             .normalize('NFD')
      //             .replace(/[\u0300-\u036f]/g, '')
      //             .toLowerCase();
      //           ps.normalizedCity = ps.city
      //             .normalize('NFD')
      //             .replace(/[\u0300-\u036f]/g, '')
      //             .toLowerCase();
      //           return ps;
      //         });
      //       setAllDpdPoints(dpdPoints);
      //       setMarkers(dpdPoints);
      //     }
      //   },
      // );
    } else {
      // request.post(
      //   {
      //     url: 'https://api.dpdportal.sk/parcelshop/json',
      //     body: `{
      //     "jsonrpc":"2.0",
      //     "method":"getAll",
      //     "id":"null"
      //   }`,
      //     json: true,
      //     headers: {
      //       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      //     },
      //   },
      //   function(error, response, body) {
      //     if (
      //       body &&
      //       body.result &&
      //       body.result.parcelshops &&
      //       body.result.parcelshops.parcelshop
      //     ) {
      //       const dpdPoints = body.result.parcelshops.parcelshop
      //         .map(ps => {
      //           ps.postcode = ps.zip || '';
      //           ps.postcode_split = `${ps.postcode.slice(0, 3) ||
      //             ''} ${ps.postcode.slice(3, 5) || ''}`;
      //           ps.id = `${ps.id}`;
      //           ps.company = ps.name || ps.company || '';
      //           ps.street = ps.street || '';
      //           ps.normalizedStreet = ps.street
      //             .normalize('NFD')
      //             .replace(/[\u0300-\u036f]/g, '')
      //             .toLowerCase();
      //           ps.normalizedCity = ps.city
      //             .normalize('NFD')
      //             .replace(/[\u0300-\u036f]/g, '')
      //             .toLowerCase();
      //           return ps;
      //         })
      //         .filter(ps => {
      //           const allowedPickups = ps.properties.property.find(
      //             p => (p.name = 'pickup_allowed'),
      //           );
      //           if (allowedPickups && allowedPickups.value) {
      //             return true;
      //           }
      //           return false;
      //         });
      //       setAllDpdPoints(dpdPoints);
      //       setMarkers(dpdPoints);
      //       if (selected && selected.dpd_payload) {
      //         setActiveShop({
      //           ...selected.dpd_payload,
      //           latitude: +selected.dpd_payload.latitude,
      //           longitude: +selected.dpd_payload.longitude,
      //         });
      //       }
      //     }
      //   },
      // );
    }
  }, []);

  const handleSearchChange = e => {
    const val = e.target.value || '';
    setSpsShopsSearchValue(val);

    setIsLoading(true);
  };

  const handleResetSearch = () => {
    setIsLoading(true);
    setSpsShopsSearchValue('');
  };

  const handleActiveShopChange = (shop: any) => {
    setActiveShop({
      ...shop,
      latitude: +shop.latitude,
      longitude: +shop.longitude,
    });
    // const nearShops = allDpdPoints.filter(s => {
    //   return s.psCity === shop.psCity;
    // });
    // setMarkers([shop, ...nearShops]);
    // setAllDpdPoints([shop, ...nearShops]);
  };

  // Po nasetovani loadera, filtrujem pobocky
  useEffect(() => {
    if (isLoading === true && spsShopsSearchValue === '') {
      if (updateDataTimeout) {
        clearTimeout(updateDataTimeout);
      }

      updateDataTimeout = setTimeout(() => {
        if (filteredResults.length !== allDpdPoints.length) {
          setFilteredResults(allDpdPoints);
        }
        if (markers.length !== allDpdPoints.length) {
          setMarkers(allDpdPoints);
        }
        if (markers.length !== allDpdPoints.length) {
          setMarkers(allDpdPoints);
        }
        setIsLoading(false);
      }, 400);
      return;
    } else if (
      isLoading === true &&
      spsShopsSearchValue &&
      spsShopsSearchValue.length >= 3
    ) {
      if (updateDataTimeout) {
        clearTimeout(updateDataTimeout);
      }

      updateDataTimeout = setTimeout(() => {
        if (allDpdPoints) {
          const normalizedSearchValue = spsShopsSearchValue
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
          const filter = allDpdPoints.filter(shop => {
            return (
              shop.postcode.includes(spsShopsSearchValue) ||
              shop.postcode.includes(spsShopsSearchValue.replace(/\s/g, '')) ||
              shop.normalizedStreet.includes(normalizedSearchValue) ||
              shop.normalizedCity.includes(normalizedSearchValue)
            );
          });
          if (filteredResults.length !== filter.length) {
            setFilteredResults(filter);
            if (filter && filter[0]) {
              const first = filter[0];
              setActiveShop({
                ...first,
                latitude: +first.latitude,
                longitude: +first.longitude,
              });
            }
          }
          if (markers.length !== filter.length) {
            setMarkers(filter);
          }
        }
        setIsLoading(false);
      }, 400);
      return;
    }
  }, [isLoading, spsShopsSearchValue]);

  // Po nastaveni filteredResults zrusim loader
  // useEffect(() => {
  //   if (isLoading === true) {
  //     setIsLoading(false);
  //   }
  // }, [filteredResults]);

  // Po zmene aktivneho shopu, nascrollujem okno na neho
  useEffect(() => {
    if (
      document !== null &&
      activeShop &&
      activeShop.id &&
      document.getElementById(activeShop.id)
    ) {
      const docElement = document.getElementById(activeShop.id);
      if (docElement) {
        docElement.scrollIntoView();
      }
    }
  }, [activeShop]);

  return (
    <MainWrapper className="fixed inset-0 bg-gray-100 bg-opacity-80 w-full h-full z-50">
      <SecondWrapper
        className={
          'absolute top-1/2 overflow-hidden left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white  h-[650px] w-4/5 max-w-7xl rounded z-50 '
        }
      >
        <HeaderWrapper
          className={
            'flex py-12 px-4 justify-between border-gray-100  border-b-2 '
          }
        >
          <Header className={'base-h2 font-bold text-textPrimary'}>
            {__('Vyberte DPD Point')}
          </Header>
          <div onClick={handleOpen}>
            <CloseIcon
              icon={IconType.close}
              alt="Zavrieť menu"
              cursor={'pointer'}
              onClick={handleOpen}
            />
          </div>
        </HeaderWrapper>
        <ThirdWrapper className={'flex flex-row w-full'}>
          <ListWrapper
            className={
              'flex flex-col w-1/3 h-[520px] overflow-scroll z-50 min-w-[320px]'
            }
          >
            <FormWrapper className="p-4 w-full max-h-[56px]">
              <CustomFormInput
                ref={ref}
                name="street_number"
                placeholder={__('Mesto/obec alebo PSČ')}
                onChange={handleSearchChange}
                className={'mt-4 border-0'}
                value={spsShopsSearchValue || ''}
              />

              {spsShopsSearchValue && spsShopsSearchValue.length > 0 ? (
                <ResetSearchButton
                  onClick={handleResetSearch}
                  className={'relative -top-[35px] -right-[230px]'}
                >
                  <CloseIcon
                    icon={IconType.close}
                    alt="Zavrieť menu"
                    cursor={'pointer'}
                    onClick={handleResetSearch}
                  />
                </ResetSearchButton>
              ) : null}
            </FormWrapper>
            {isLoading ? (
              <Loader style={{ top: '80px' }} loading={true} />
            ) : (
              <>
                <CountText className="p-4">
                  {__(`Počet nájdených odberných miest: `)}{' '}
                  <strong>
                    {filteredResults.length > 0
                      ? filteredResults.length
                      : allDpdPoints.length}
                  </strong>
                </CountText>
                <DetailWrapper
                  className={
                    'w-full border-gray-100 max-h-[400px] lg:max-h-[450px] overflow-scroll '
                  }
                >
                  {filteredResults.length > 0
                    ? filteredResults.map(shop => {
                        const xShop: any = shop;
                        return (
                          <DpdMapDetail
                            key={xShop.id}
                            shop={shop}
                            handleActiveShopChange={handleActiveShopChange}
                            isActive={activeShop && xShop.id === activeShop.id}
                            handleChooseShop={handleChoose}
                          />
                        );
                      })
                    : allDpdPoints.map(shop => {
                        return (
                          <DpdMapDetail
                            key={shop.id}
                            shop={shop}
                            handleActiveShopChange={handleActiveShopChange}
                            isActive={activeShop && shop.id === activeShop.id}
                            handleChooseShop={handleChoose}
                          />
                        );
                      })}
                </DetailWrapper>
              </>
            )}
          </ListWrapper>
          {/* <MapWrapper className="w-full h-[520px] overflow-hidden">
            <DpdMap
              activeShop={activeShop}
              markers={markers}
              onChangePointItem={handleActiveShopChange}
              country={'sk'}
            />
          </MapWrapper> */}
          <DpdMapWrapper>
            <DpdMap
              isLoading={isLoading}
              activeShop={activeShop}
              markers={markers}
              onChangePointItem={handleActiveShopChange}
              country={'sk'}
              lang={lang}
            />
          </DpdMapWrapper>
        </ThirdWrapper>
      </SecondWrapper>
    </MainWrapper>
  );
}

export { DpdMapModal };
